<template>
  <div class="login-container">
    <div class="fx_paper">
      <div class="fx_wrap">
        <h3 class="fx_h3">
          <template v-if="systemName">
            <span v-if="logoTxt" class="logo_txt">{{logoTxt}}</span>
            <img v-else-if="logoImg" class="logo_xs" :src="logoImg"/>
            <el-divider v-if="logoImg" direction="vertical"></el-divider>
            <span class="title">{{systemName}}</span>
          </template>
          <span v-else-if="logoTxt" class="logo_txt">{{logoTxt}}</span>
          <img v-else-if="logoImg" class="logo" :src="logoImg"/>
        </h3>
        <div class="mid_line"></div>
        <div class="login_types_wrap" v-if="loginTypeStatus">
          <div v-if="loginTypes.includes('password')" class="type_item" @click="typeChange('password')" :class="{type_item_active: loginType==='password' }">密码登录</div>
          <div v-if="loginTypes.includes('code')" class="type_item" @click="typeChange('code')" :class="{type_item_active: loginType==='code' }">验证码登录</div>
          <div v-if="loginTypes.includes('qrCode')" class="type_item" @click="typeChange('qrCode')" :class="{type_item_active: loginType==='qrCode' }">扫码登录</div>
        </div>
        <div class="form_wrap"
          :style="{paddingTop: loginTypeStatus ? '10px':'40px'}"
        >
          <el-form  :model="ruleForm" :rules="rules" ref="ruleForm">
            <div v-if="loginType === 'password'">
              <el-form-item label="" prop="account" class="input-item">
                <el-input id="form-username" v-model="ruleForm.account" placeholder="请输入工号/用户名" prefix-icon="el-icon-user" clearable @keydown.enter.native.stop.prevent="focusPassword"></el-input>
              </el-form-item>
              <el-form-item label="" prop="password" class="input-item">
                <el-input ref="passwordInput" :type="passwordType" v-model="ruleForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" clearable>
                  <i
                  slot="suffix"
                  class="el-icon-view el-input__icon"
                  title="显示密码"
                  @click="passwordType='text'"
                  style="cursor:pointer;"
                  v-if="passwordType=='password'"
                ></i>
                <i
                  slot="suffix"
                  class="el-icon-more el-input__icon"
                  title="隐藏密码"
                  @click="passwordType='password'"
                  style="cursor:pointer;"
                  v-else
                ></i>
                </el-input>
              </el-form-item>
              <el-form-item v-if="needValidate" label="" prop="validateCode" class="wordCode-item">
                <el-input v-model="ruleForm.validateCode" placeholder="填写验证码" clearable></el-input>
                <img :src="validateUrl" @click="validateChange"/>
              </el-form-item>
            </div>
            <div v-if="loginType === 'code'">
              <el-form-item prop="mobile" class="input-item">
                <el-input id="form-username" v-model="ruleForm.mobile" placeholder="请输入手机号码" prefix-icon="el-icon-mobile-phone" clearable></el-input>
              </el-form-item>
              <el-form-item prop="code" class="fx_verification">
                <el-input v-model="ruleForm.code" placeholder="请填写验证码" clearable></el-input>
                <el-button type="default" size="mini" @click="getVerificationCode">{{timeText}}</el-button>
              </el-form-item>
            </div>
            <div v-if="loginType === 'qrCode'" class="qr-box">
              <img :src="qrCodeUrl"/>
              <div class="tip-box" v-if="overTimeShow">
                <div>二维码已过期</div>
                <div>请重新获取</div>
                <span class="refresh-button" @click="changeQrCode">刷新</span>
              </div>
              <div class="bottom-tip">
                <span style="color:#fff">请使用手机扫码登录</span><span style="color:#fff" v-if="isShowQrOverTime">({{ qrNowTime }}s)</span>
                <i style="color:#00C0EF;cursor:pointer" class="el-icon-refresh-right" @click="changeQrCode">刷新二维码</i>
              </div>
            </div>
            <el-form-item v-if="loginType !== 'qrCode'" class="btn" label-width="0px">
                <el-button
                  :loading="logining"
                  type="primary"
                  @click.stop="handleSubmit">
                  登录
                </el-button>
            </el-form-item>
          </el-form>
          <div class="bottom-box">
              <el-checkbox v-if="needKeepLogin" label="保持登录状态" v-model="keepLoginValue" @change="keepLoginChange"></el-checkbox>
              <div v-if="loginTypes.includes('otherLogin')" class="other-login">
                <span class="mr-10" style="line-height: 19px;">其他登录方式</span>
                <!-- <img src="../../../examples/assets/images/kayilogin.png" width="30px" @click="otherLogin('kayi')"/> -->
                 <span class="circle-button" @click="otherLogin('kayi')">{{otherLoginLabel}}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import QRCode from 'qrcode' 
let mobileReg = /^[1][3,4,5,7,8][0-9]{9}$/
export default {
  name: 'kyVLogin',
  components: {},
  props:{
    systemName: { // 系统名称
      String,
      default: ''
    },
    loginTypes:{ // 登录类型
      // password, code
      type: [Array , String],
      default: 'password'
    },
    logoImg:{ // logo 图片
      String,
      default:''
    },
    logoTxt:{ // logo 文字
      String,
      default:''
    },
    loadingLogin:{ // 登录提交状态
      Boolean,
      default: false
    },
    countdown:{ // 验证码计时器开始判断
      Boolean,
      default: false
    },
    downTime: { // 倒计时的时间
      Number,
      default: 60
    },
    qrData:{ // 二维码内容
      String,
      default: ''
    },
    qrUrl:{// 二维码地址
        String,
        default: ''
    },
    qrOverFlag:{ //二维码是否过期
      Boolean,
      default: false
    },
    qrOverTime:{//二维码过期时间
        Number,
        default:60
    },
    isShowQrOverTime:{//是否显示二维码过期时间
        Boolean,
        default:true
    },
    needValidate:{//是否需要验证字符码
        Boolean,
        default:false
    },
    validateUrl:{//字符码图片地址
        String,
        default:''
    },
    needKeepLogin:{//是否需要显示保持登录状态
        String,
        default:false
    },
    keepLogin:{//保持登录状态赋值字段
        String,
        default:false
    },
    otherLoginLabel:{//其他登录方式的label
        String,
        default:'CA'
    }
  },
  data() {
    const validatorMobile = (rule, value, callback)=>{
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        if (!mobileReg.test(value)) {
          callback(new Error('手机号码格式不正确'))
        }
        callback()
      }
    }
    return {
      loginTypeStatus: false, // 切换是否显示
      loginType: 'password', // password, code,qrCode
      ruleForm: {
        account: '',
        password: '',
        mobile: '',
        code: '',
        validateCode:''
      },
      rules: {
        account: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            validator: validatorMobile,
            trigger: 'change'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
      },
      visible: true,
      redirect: '',
      otherQuery: '',
      dialogVisible: false, // 告知书
      passwordType: 'password',
      timeText: '获取验证码',
      keepLoginValue:false,
      timer: null,
      qrCodeUrl:'',
      overTimeShow:false,
      qrNowTime:0//展示的当前倒计时时间
    }
  },
  created() {
    this.keyupSubmit() // 回车登录
    this.typesHandler(this.loginTypes)
  },
  mounted() {
    var onFocus = document.querySelector('#form-username')
    onFocus.focus()
    // this.getQrCode('http://www.baidu.com')
    // this.qrCodeUrl = 'data:image/png;base64,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'
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      }
    },
    countdownFlag(val){
      if(val) {
        this.countdownStart()
      }else{
        this.countdownClear()
      }
    },
    qrData:{
        handler(val){
            if(val){
                this.getQrCode(val)
            }
        },
        immediate:true
    },
    qrOverFlag(val){
        this.overTimeShow = val
    },
    qrUrl:{
        handler(val){
            if(val){
                this.qrCodeUrl = val
            }
        },
        immediate:true
    },
    qrCodeUrl:{//真正展示的二维码
        handler(val){
            if(val){
                this.setExpiresTime(this.qrOverTime)//开始倒计时
            }
        },
        immediate:true
    },
    keepLogin:{
        handler(val){
            this.keepLoginValue = val
        },
        immediate:true
    }
  },
  computed: {
    logining: {
      get() {
        return this.loadingLogin
      },
      set(val) {
        this.$emit('update:loadingLogin', val)
      }
    },
    countdownFlag:{
      get() {
        return this.countdown
      },
      set(val) {
        this.$emit('update:countdown', val)
      }
    }
  },
  methods: {
    getQrCode(data){
        // 生成二维码
        QRCode.toDataURL(data,{ errorCorrectionLevel: 'H',margin: 1 })
        .then(url => {
            this.qrCodeUrl = url
            console.log(url)
        })
        .catch(err => {
            console.error(err)
        })
    },
    changeQrCode(){//点击切换二维码
        this.$emit('changeQrCode')
        this.overTimeShow = false
    },
    /** 二维码倒计时 */
    setExpiresTime(time) {
      this.qrNowTime = time
      this.overTimeShow = false
        if(this.timer1){
            clearInterval(this.timer1);
        }
      this.timer1 = setInterval(() => {
        if (this.qrNowTime === 0) {
          clearInterval(this.timer1);
          this.timer1 = null;
          this.overTimeShow = true
        } else {
          this.qrNowTime--
          this.$emit('qrExpiresTimeFunc')
        }
      }, 1000)
    },
    // 传入的登录类型判断
    typesHandler(val) {
      if(typeof val === 'object') {
        this.loginType = val[0]
        this.loginTypeStatus = val.length > 1
      }else{
        this.loginType = val || 'password'
      }
    },
    // 登录类型变换
    typeChange(val) {
      this.loginType = val
      const _form = {...this.ruleForm}
      this.$refs.ruleForm.resetFields()
      this.$nextTick(()=>{
        this.ruleForm = {..._form}
      })
      this.$emit('typeChange',val)
    },
    keyupSubmit() {
      // 回车登录
      document.onkeydown = e => {
        let _key = window.event.keyCode
        if (_key === 13) {
          this.handleSubmit()
        }
      }
    },
    focusPassword() {
      const input = this.$refs.passwordInput
      if (input && typeof input.focus === 'function') {
        input.focus()
      }
    },
    // 提交（防抖：1s 内重复触发会被忽略，避免回车/连点导致重复提交）
    handleSubmit() {
      if (this._submitLock) return
      this._submitLock = true
      setTimeout(() => { this._submitLock = false }, 1000)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var loginParams = {
            type: this.loginType,
            ...this.ruleForm
          }
          this.logining = true
          this.$emit('handleSubmit',loginParams)
        } else {
          return false
        }
      })
    },
    // 密码显示状态切换
    changePass(value) {
      this.visible = !(value === 'show')
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // 获取验证码
    getVerificationCode() {
      if(this.timeText !== '获取验证码') return
      this.$refs.ruleForm.validateField('mobile', (msg)=>{
        // 表单验证，手机号码。返回空，通过验证
        if(!msg) {
          this.$emit('sendSMS',this.ruleForm.mobile);
          // 倒计时
          // this.countdown()
        }
      })
    },
    // 开始计时器
    countdownStart() {
      let time = this.downTime
      this.timeText = `${time}s`
      this.timer = setInterval(() => {
        time--
        this.timeText = `${time}s`
        this.$forceUpdate()
        if(time<=0){
          this.countdownClear()
        }
      }, 1000)
    },
    // 清除计时器
    countdownClear() {
      if(this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.timeText = '获取验证码'
      this.countdownFlag = false
    },
    validateChange(){//字符码切换
        this.$emit('validateChange')
    },
    otherLogin(type) {
        this.$emit('otherLogin',type)
    },
    keepLoginChange(val){
        this.$emit('update:keepLogin',val)
    }
  },
  beforeDestroy() {
    document.onkeydown = ()=>{}
  }
}
</script>

<style lang="scss" scoped>
$bg: #31414f;
.login-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: $bg;
  .btns{
    position: absolute;
    bottom: 30px;
    left: 40px;
  }
  .fx_paper {
    display: flex;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    justify-content: center;
    transform: translate(-50%, -50%);
    background-color: $bg;
    .fx_wrap {
      width: 100%;
      height: 100%;
      .fx_h3 {
        font-size: 30px;
        text-align: center;
        margin: 10px 0 20px;
        // padding-right: 20px;
        .logo_txt{
          font-size: 26px;
          font-weight: 500;
          padding: 0 32px;
          color: #fff;
        }
        .logo_xs {
          height: 80px;
          vertical-align: middle;
        }
        .logo {
          height: 90px;
          vertical-align: middle;
        }
        .title{
          font-size: 26px;
          font-weight: 500;
          color: #fff;
          padding: 0 6px;
        }
      }
    }
  }
  .link{
    cursor: pointer;
    color: #409EFF;
    position: absolute;
    left: 25px;
    bottom: 14px;
  }
}
.form_wrap /deep/ .el-form-item__label{
  color: #fff;
  line-height: 35px;
}
.form_wrap /deep/ .el-form-item__label::before{
  display: none;
}
.form_wrap /deep/ .el-input__inner{
  height: 35px;
}
.form_wrap /deep/ .el-input__icon{
  line-height: 35px;
}
.form_wrap /deep/ .el-input{
  width: 68%;
}
.form_wrap /deep/ .el-form-item{
  margin-bottom: 15px;
}
.form_wrap /deep/ .el-form-item__content{
  line-height: 35px;
}
.form_wrap /deep/ .el-form-item__error{
  padding-top: 1px;
}
.form_wrap{
  width: 400px;
  margin: 0 auto;
  // box-shadow: 3px 3px 3px 0px #293742 , 1px 1px 0px 0px #405565 inset;
  padding: 10px 40px 25px;
  position: relative;
  box-sizing: border-box;
  .el-form{
    position: relative;
  }
  .btn{
   /*  position: absolute;
    display: inline-block;
    top: 0px;
    right: 0px; */
    .el-button{
      width: 320px;
      height: 36px;
      margin-top: 10px;
    }
  }
}
.el-checkbox{
    color:#fff;
}

.wordCode-item{
   /deep/ .el-form-item__content{
        display: flex;
        .el-input{
            width: 52%;
        }
        img{
            width:calc(48% - 10px);
            height: 35px;
            margin-left: 10px;
            cursor:pointer;
        }
    }
}
.input-item{
    /deep/ .el-form-item__content{
        .el-input{
            width: 320px;
            height:36px;
        }
    }
}

.el-divider--vertical{
  margin-left: -20px;
  opacity: 0.5;
}
.mid_line{
  margin: 0 auto;
  opacity: 0.5;
  width: 600px;
  height: 1px;
  background: linear-gradient(left bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%)
}
.fx_verification{
  width:100%;
}
.fx_verification /deep/ .el-form-item__content{
  display: flex;
}
.fx_verification /deep/ .el-input--suffix{
  width: 69%;
}
.fx_verification /deep/.el-button{
  width: 90px;
  padding: 7px 4px;
  margin-left: 10px;
  border-radius: 4px;
  color: #00C0EF;
}
.login_types_wrap{
  display: flex;
  justify-content: center;
//   padding-right: 104px;
  margin-top: 6px;
  font-size: 14px;
  color: #fff;
  .type_item{
    margin: 10px;
    padding: 2px 0;
    cursor: pointer;
    &:hover{
      color: #00C0EF;
    }
  }
  .type_item_active{
    color: #00C0EF;
    border-bottom: solid 1px #00C0EF;
  }
}
.qr-box{
    text-align: center;
    // width: 200px;
    img{
        width: 200px;
    }
    .tip-box{
        width: 200px;
        height: 200px;
        text-align: center;
        color: gray;
        padding-top: 60px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: calc(50% - 100px);
        background:rgba(0,0,0,0.7);
        color: #fff;
        font-weight: 600;
        span,div{
            margin-bottom:8px;
            font-size: 13px;
        }
        .refresh-button{
            padding:5px 20px;
            background:#00C0EF;
            border-radius: 15px;
            display: inline-block;
            cursor: pointer;
        }
    }
    .bottom-tip{
        margin-top: 10px;
        span,i{
            font-size: 13px;
        }
    }
}
.bottom-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}
.other-login{
    color: #fff;
    text-align: center;
    display: flex;
    float: right;
    align-items: center;
   /*  span::before{
        content:"";
        width:calc(50% - 95px);
        height: 1px;
        background: #6c6c6c;
        display: inline-block;
        margin-right: 30px;
        margin-left: 34px;
    }
    span::after{
        content:"";
        width:calc(50% - 95px);
        height: 1px;
        background: #6c6c6c;
        display: inline-block;
        margin-left: 30px;
    } */
    img{
        /* margin-top:15px; */
        cursor: pointer;
        /* margin-left: 34px; */
    }
    .circle-button{
        cursor:pointer;
        width:30px;
        height:30px;
        border-radius:15px;
        background: #00C0EF;
        color:#ffffff;
        font-weight:600;
        font-size:18px;
        line-height:30px;
    }
  }
  .mr-10{
    margin-right: 10px;
  }
</style>




// WEBPACK FOOTER //
// packages/vlogin/src/VLogin.vue